import{ useRef, useEffect, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import axios from 'axios';
import { REACT_APP_UPLOADS } from '../../../constants';
import { uploadData } from '../../../constants/uploadData';

window.navigateToLogin = function () {
  window.location.href = '/accounts/login'; // Or use any routing logic
};

mapboxgl.accessToken = "pk.eyJ1Ijoia2FidWltdXJpaXRoaSIsImEiOiJjbWJ0Zm5hY3UwM2I1MmtzMGR2aW10NTl5In0.GVgsbN2VdblT43_9zpGJuw";

const GlobeMap = () => {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [data, setData] = useState([]);

        useEffect(() => {
            axios.get(`${REACT_APP_UPLOADS}/api/v1/seizure-cases/all-cases`, {
                  headers: {
                    "ngrok-skip-browser-warning": "true"
                  }
                }).then(function(res){
                if(res.status === 200){
                  console.log(res.data)
                    setData(res.data);
                } else {
                    console.log("Error fetching data", res.data?.message);
                }
            }).catch(function(){
                console.log("An error occured")
            })
        }, [])

  useEffect(() => {
    if (map.current) return;

    const features = uploadData
      .filter(d => d.latitude !== null && d.longitude !== null)
      .map(d => ({
        type: 'Feature',
        properties: {
          species: d.species,
          weight: parseFloat(d.weight) || 1,
          accused: d.nameOfAccused,
          location: d.location,
          dateOfSeizure: d.dateOfSeizure,
          nationality: d.nationality,
          charge1: d.charge1,
          exhibit: d.exhibit,
        },
        geometry: {
          type: 'Point',
          coordinates: [d.longitude, d.latitude]
        }
      }));

    const geojson = {
      type: 'FeatureCollection',
      features
    };

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/standard',
      center: [37, 0], // Center on Kenya
      zoom: 2,
      antialias: true,
      projection: 'globe',
      scrollZoom: false
    });

    // Add zoom & rotation controls to the top-right corner
map.current.addControl(new mapboxgl.NavigationControl(), 'top-right');

// Add geolocation control to the top-left
map.current.addControl(new mapboxgl.GeolocateControl({
  positionOptions: {
    enableHighAccuracy: true
  },
  trackUserLocation: true,
  showUserHeading: true
}), 'top-left');

    map.current.on('load', () => {
      map.current.addSource('cases', {
        type: 'geojson',
        data: geojson,
        cluster: true,
        clusterMaxZoom: 14,
        clusterRadius: 50
      });

      // Cluster circles
      map.current.addLayer({
        id: 'clusters',
        type: 'circle',
        source: 'cases',
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': [
            'step',
            ['get', 'point_count'],
            '#FFB6B6', 10,
            '#FF5A5F', 30,
            '#C81D25'
          ],
          'circle-radius': [
            'step',
            ['get', 'point_count'],
            15, 10,
            20, 30,
            25
          ]
        }
      });

      // Cluster count labels
      map.current.addLayer({
        id: 'cluster-count',
        type: 'symbol',
        source: 'cases',
        filter: ['has', 'point_count'],
        layout: {
          'text-field': '{point_count_abbreviated}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12
        }
      });

      // Unclustered points
      map.current.addLayer({
        id: 'unclustered-point',
        type: 'circle',
        source: 'cases',
        filter: ['!', ['has', 'point_count']],
        paint: {
          'circle-radius': [
            'interpolate', ['linear'], ['get', 'weight'],
            0, 4,
            50, 12,
            300, 20
          ],
          'circle-color': '#FF5A5F',
          'circle-opacity': 0.8
        }
      });

      // Sticky popup on click for unclustered points
let activePopup = null;

// Handle click on unclustered points
map.current.on('click', 'unclustered-point', (e) => {
  const props = e.features[0].properties;

  // Prevent multiple popups
  if (activePopup) activePopup.remove();

  activePopup = new mapboxgl.Popup({
    offset: 25,
    closeButton: false,
    closeOnClick: false
  })
    .setLngLat(e.lngLat)
    .setHTML(`
      <div class="custom-popup">
        <p><strong>Nationality:</strong> ${props.nationality}</p>
        <p><strong>Name of Accused:</strong> ${props.nameOfAccused}</p>
        <p><strong>Date of Seizure:</strong> ${props.dateOfSeizure}</p>
        <p><strong>Location:</strong> ${props.location}</p>
        <p><strong>Endangered Species Involved:</strong> ${props.species}</p>
        <p><strong>Charges:</strong> ${props.charge1}</p>
        <p><strong>Exhibit:</strong> ${props.exhibit}</p>
        <p><strong>Weight:</strong> ${props.weight} kg</p>
        <button onclick="navigateToLogin()" class="popup-btn">SUBSCRIBE TO POINT CHANGES</button>
      </div>
    `)
    .addTo(map.current);

  // Optional: prevent clicks inside popup from closing it
  setTimeout(() => {
    const el = document.querySelector('.mapboxgl-popup-content');
    if (el) el.addEventListener('click', e => e.stopPropagation());
  }, 0);
});

// Remove popup when clicking anywhere else on the map
map.current.on('click', (e) => {
  const features = map.current.queryRenderedFeatures(e.point, {
    layers: ['unclustered-point']
  });

  if (!features.length && activePopup) {
    activePopup.remove();
    activePopup = null;
  }
});

// Optional: cursor feedback
map.current.on('mouseenter', 'unclustered-point', () => {
  map.current.getCanvas().style.cursor = 'pointer';
});
map.current.on('mouseleave', 'unclustered-point', () => {
  map.current.getCanvas().style.cursor = '';
});


      // Optional: Zoom into cluster on click
      map.current.on('click', 'clusters', (e) => {
        const features = map.current.queryRenderedFeatures(e.point, {
          layers: ['clusters']
        });
        const clusterId = features[0].properties.cluster_id;
        map.current.getSource('cases').getClusterExpansionZoom(
          clusterId,
          (err, zoom) => {
            if (err) return;

            map.current.easeTo({
              center: features[0].geometry.coordinates,
              zoom
            });
          }
        );
      });
    });

    // Optional globe fog for a nice look
    map.current.on('style.load', () => {
      map.current.setFog({});
    });
  }, []);

  return (
    <div
      ref={mapContainer}
      style={{ width: '100%', height: '100vh' }}
    >
    </div>
  );
};

export default GlobeMap;
